import CallOutboundPricingTable from "./CallOutboundPricingTable/CallOutboundPricingTable";
import LeedbucksRates from "./LeedbucksRates/LeedbucksRates";
import WorkflowsSettings from "./WorkflowsSettings/WorkflowsSettings";

export default {
    CallOutboundPricingTable,
    LeedbucksRates,
    WorkflowsSettings,
}
